import { defineMessages } from 'react-intl';

import type { OpportunityStatusFilterValueKey } from '../../../../../common/constants/filters/opportunity-status-filter';

export const opportunityStatusLabels: Record<
	'all' | OpportunityStatusFilterValueKey,
	import('react-intl').MessageDescriptor
> = defineMessages<OpportunityStatusFilterValueKey | 'all'>({
	all: {
		id: 'search-page.filter.opportunityStatus.all',
		defaultMessage: 'Any',
		description: 'Any opportunity status (no filter applied)',
	},
	open: {
		id: 'search-page.filter.opportunityStatus.open',
		defaultMessage: 'Open',
		description: 'Open opportunity status',
	},
	closed: {
		id: 'search-page.filter.opportunityStatus.closed',
		defaultMessage: 'Closed',
		description: 'Closed opportunity status',
	},
});
